import React from 'react'
import styles from './Svg.css'

const Svg = ({id, className, style}) => (
  <svg className={`${styles[id]} ${className ? className : ''}`} style={style}>
    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={`#svg-${id}`}/>
  </svg>
)

export default Svg



// WEBPACK FOOTER //
// ./src/components/Svg/Svg.js